import { useSelector } from 'react-redux';
import { ServicePriceIcon, ServiceTimeIcon } from '../../assets/svg/iconos';
import { formatCurrency } from '../../helpers/helpers';
import { useServiceImage } from '../../hooks/useServiceImage';

export const ServicioCardReserva = ({ servicio, isSelected, onToggle, disabled = false }) => {
    const { colores } = useSelector(state => state.ui);
    const imageUrl = useServiceImage(servicio);

    return (
        <div
            className={`servicio-card-reserva ${isSelected ? 'servicio-card-reserva--selected' : ''} ${disabled ? 'servicio-card-reserva--disabled' : ''}`}
            onClick={() => !disabled && onToggle(servicio)}
            role="button"
            tabIndex={disabled ? -1 : 0}
            onKeyDown={(e) => !disabled && e.key === 'Enter' && onToggle(servicio)}
            aria-disabled={disabled}
        >
            <div
                className="servicio-card-reserva__img"
                style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : 'none' }}
            />
            <div className="servicio-card-reserva__body">
                <p className="servicio-card-reserva__nombre">{servicio.nombre}</p>
                {servicio.descripcion && String(servicio.descripcion).trim() && (
                    <p className="servicio-card-reserva__descripcion" title={servicio.descripcion}>
                        {servicio.descripcion}
                    </p>
                )}
                <div className="servicio-card-reserva__meta">
                    <span className="servicio-card-reserva__meta-item">
                        <ServiceTimeIcon />
                        {servicio.duracion}'
                    </span>
                    <span className="servicio-card-reserva__meta-item">
                        <ServicePriceIcon />
                        {formatCurrency(servicio.precio)}
                    </span>
                </div>
            </div>
            {isSelected && (
                <div
                    className="servicio-card-reserva__check"
                    style={{ backgroundColor: colores.colorPrincipal }}
                >
                    <span className="servicio-card-reserva__check-icon">✓</span>
                </div>
            )}
        </div>
    );
};
